import { CreatorShopFanLetterPage } from './CreatorShopFanLetterPage';

export const creatorShopFanLetterRouter = {
  '/fan-letter': CreatorShopFanLetterPage,
};
